(function ($) {
    "use strict";
    jQuery(document).ready(function ($) {

        $('.content-slider-wrapper').each(function () {

            var $this = $(this);

            if ($this.find('.content-image-slider').length) {
                $this.find('.content-image-slider').slick({
                    dots: false,
                    arrows: true,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    draggable: true,
                    swipe: true,
                    touchMove: true,
                    swipeToSlide: true,
                    centerMode: false,
                    autoplay: true,
                    autoplaySpeed: 4000,
                    prevArrow: $this.find('.content-image-prev'),
                    nextArrow: $this.find('.content-image-next'),
                    responsive: [
                        {
                            breakpoint: 1050,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
            }
        if ($this.find('.product-slider').length) {
        $this.find('.product-slider').slick({
            dots: false,
            arrows: true,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            draggable: true,
            swipe: true,
            touchMove: true,
            swipeToSlide: true,
            centerMode: false,
            autoplay: true,
            autoplaySpeed: 4000,
            prevArrow: $this.find('.product-slider-prev'),  
            nextArrow: $this.find('.product-slider-next'),   
            responsive: [
                { breakpoint: 1050, settings: { slidesToShow: 2 } },
                { breakpoint: 991,  settings: { slidesToShow: 1 } },
                { breakpoint: 480,  settings: { slidesToShow: 1 } }
            ]
        });
    }

        });
        

        if ($('.hero-slider').length) {
            $('.hero-slider').slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 5000,
                fade: true,
                prevArrow: $('.hero-image-prev'),
                nextArrow: $('.hero-image-next'),
            });
        }

        if ($('.page-banner-slider').length) {
            $('.page-banner-slider').slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 5000,
                fade: true,
                prevArrow: $('.hero-image-prev'),
                nextArrow: $('.hero-image-next'),
            });
        }

     

        if ($('.content-image-slider.style2').length) {
            $('.content-image-slider.style2').slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 4000,
                slidesToShow: 10,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                pauseOnHover: false,
                pauseOnFocus: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3,
                        }
                    }
                ]
            });
        }

        if ($('.content-image-slider.style3').length) {
            $('.content-image-slider.style3').slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 4000,
                slidesToShow: 10,
                slidesToScroll: 1,
                rows: 2,
                autoplay: true,
                autoplaySpeed: 0,
                cssEase: 'linear',
                pauseOnHover: false,
                pauseOnFocus: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            rows: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4,
                            rows: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 3,
                            rows: 2
                        }
                    }
                ]
            });
        }

        AOS.init({
            duration: 1200,
            disable: function () {
                return window.innerWidth < 768;
            }
        });


        // Both wrappers must exist together — asNavFor on a missing element crashes
        // slick's initADA with a null error, halting the entire jQuery ready block
        // and killing the mobile menu toggle. Guard both + wrap in try/catch.
        if ($('.tabs_img_wrapper').length && $('.tabs_thumb_wrapper').length) {
            try {
                $('.tabs_img_wrapper').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    infinite: false,
                    asNavFor: '.tabs_thumb_wrapper'
                });
                $('.tabs_thumb_wrapper').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    asNavFor: '.tabs_img_wrapper',
                    dots: false,
                    centerMode: false,
                    focusOnSelect: true,
                    infinite: false
                });
            } catch(e) {
                console.warn('Product image slider failed to initialise:', e);
            }
        }

        //Mobile Menu Start
        $(document).ready(function () {
            // Scope to #menu only — do NOT prepend spans into .has-submenu elements
            // inside the theme's header-drawer component, as that corrupts the drawer DOM
            $("#menu .has-submenu").prepend("<span></span>");
        });
        $(document).on('click', '#menu .has-submenu > span', function (event) {
            $(this).parent().find("ul").toggleClass("active");
            $(this).parent().toggleClass("active");
        });

        $(".mainmenu ul li:has(ul)").addClass("has-submenu");
        $(".mainmenu ul li:has(ul)").addClass("small-submenu");
        $(".mainmenu ul li ul").addClass("sub-menu");
        $(".mainmenu ul.dropdown li").hover(function () {
            $(this).addClass("hover");
        }, function () {
            $(this).removeClass("hover");
        });
        var $menu = $("#menu"),
            $menulink = $("#menu-toggle"),
            $header = $(".header-area"),
            $searchTrigger = $(".search-toggle"),
            $menuTriggercont = $("#menu_handler"),
            $menuTrigger = $(".has-submenu > span"),
            $body = $("body"),
            $megamenuTrigger = $(".megamenu > li > span");
        $menulink.click(function (e) {
            $menulink.toggleClass("active");
            $menu.toggleClass("active");
            $menuTriggercont.toggleClass("active");
            $header.toggleClass("active");
            $body.toggleClass("active");
        });

        $menuTrigger.click(function (e) {
            e.preventDefault();
            var t = $(this).next();
            t.toggleClass("active");
            t.toggleClass("active").next("ul").toggleClass("active");
            t.toggleClass("active").next(".megamenu-holder").toggleClass("active");
        });

        $megamenuTrigger.click(function (e) {
            e.preventDefault();
            var t = $(this).next();
            t.toggleClass("active").next(".mega-submenu").toggleClass("active");
        });

        $searchTrigger.click(function (e) {
            $menulink.removeClass("active");
            $menu.removeClass("active");
            $menuTriggercont.removeClass("active");
        });

        $(".mainmenu ul li:has(ul)");
        //Mobile Menu End

        // open search
        $('.search-toggle').on('click', function () {
            $('.header-search-form').addClass('active');
        });

        // close button
        $('.close-search').on('click', function () {
            $('.header-search-form').removeClass('active');
        });

        // click outside
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.header-search-form, .search-toggle').length) {
                $('.header-search-form').removeClass('active');
            }
        });

        const btn = document.getElementById("dropdownBtn");
        const menu = document.getElementById("dropdownMenu");
        const arrow = document.getElementById("arrow");
        const items = document.querySelectorAll(".item");

        const selectedText = document.getElementById("selectedText");
        const selectedFlag = document.getElementById("selectedFlag");

        if (btn && menu && arrow) {
            btn.onclick = function () {
                menu.classList.toggle("show");
                arrow.classList.toggle("rotate");
            };

            items.forEach(item => {
                item.onclick = function () {
                    if (selectedText) selectedText.innerText = this.dataset.text;
                    if (selectedFlag) selectedFlag.src = this.dataset.flag;
                    menu.classList.remove("show");
                    arrow.classList.remove("rotate");
                };
            });

            window.addEventListener('click', function (e) {
                if (!btn.contains(e.target) && !menu.contains(e.target)) {
                    menu.classList.remove("show");
                    arrow.classList.remove("rotate");
                }
            });
        }

        $(".et-js-tilt").tilt({
            scale: 1.01,
            glare: false,
            maxGlare: 0.8,
            easing: "cubic-bezier(.03,.98,.52,.99)",
            speed: 900,
            perspective: 1200
        });

        // open filter
        $('.open-filter').on('click', function () {
            $('.filters-wrapper').addClass('active');
        });

        // close filter
        $('.close-filter').on('click', function () {
            $('.filters-wrapper').removeClass('active');
        });

        function initMobileFilterToggle() {
            const isMobile = $(window).width() <= 992;

            // Always remove first to avoid duplicate bindings
            $('.filter-button').off('click.mobile');

            if (isMobile) {
                $('.filter-button').on('click.mobile', function (e) {
                    e.preventDefault();

                    const $button = $(this);
                    const $parent = $button.closest('.filter-item');
                    const $dropdown = $parent.find('.filter-dropdown');

                    // toggle dropdown
                    $dropdown.stop(true, true).slideToggle(300);

                    // toggle active states
                    $button.toggleClass('active');
                    $parent.toggleClass('open');
                });
            }
        }

        // run on load
        $(document).ready(function () {
            initMobileFilterToggle();
        });

        // run on resize (debounced for stability)
        let resizeTimer;
        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                initMobileFilterToggle();
            }, 150);
        });


    });
}(jQuery));

document.addEventListener("DOMContentLoaded", function () {

    const radios = document.querySelectorAll('input[name="shirt"]');
    const items = document.querySelectorAll('.item-text');
    const desktopBg = document.querySelectorAll('.players-bg');
    const mobileBg = document.querySelectorAll('.players-bg-mob-img');

    function showItem(target) {

        items.forEach(item => {
            item.classList.remove("active");
            if (item.dataset.id === target) {
                item.classList.add("active");
            }
        });

        desktopBg.forEach(bg => {
            bg.classList.remove("active");
            if (bg.dataset.id === target) {
                bg.classList.add("active");
            }
        });

        mobileBg.forEach(bg => {
            bg.classList.remove("active");
            if (bg.dataset.id === target) {
                bg.classList.add("active");
            }
        });
    }

    radios.forEach(radio => {
        radio.addEventListener("change", function () {
            showItem(this.dataset.target);
        });
    });

    const checked = document.querySelector('input[name="shirt"]:checked');
    if (checked) {
        showItem(checked.dataset.target);
    }

});

document.addEventListener("DOMContentLoaded", function () {

    const links = document.querySelectorAll("a[href]");

    links.forEach(link => {
        const href = link.getAttribute("href");

        if (!href || href.startsWith('#') | href.startsWith('javascript:;') || href.startsWith('mailto:') || href.startsWith('tel:')) {
            return;
        }

        if (link.hostname !== window.location.hostname) {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener noreferrer");
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
  const captchaForms = ['enquiry-form', 'quote-form']
    .map(id => document.getElementById(id))
    .filter(Boolean);

  captchaForms.forEach(form => {
    let wired = false;
    const wireUp = () => {
      if (wired || !window.Shopify || !window.Shopify.captcha) return;
      wired = true;
      window.Shopify.captcha.protect(form);
    };
    // Attach on first real interaction, not on page load
    form.addEventListener('focusin', wireUp, { once: true });
  });
});